<button matRipple class="back-button" type="button">
	<div class="back-button-content">
		<div *bpIfGreaterThan="'Phone'">Go back</div>

		<div class="flex"><mat-icon class="material-icons-round bp-icon-xxs">arrow_back_ios</mat-icon></div>
	</div>
</button>
